module.exports = __webpack_public_path__ + "static/media/barChart.cf3762d6.svg";